import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Stack } from "@mui/material";
import "./components.css";
import { useTranslation } from "react-i18next";

function StackButtons(props) {
  const {t} = useTranslation();
  const {disabled, name} = props;
  const [value, setValue] = useState();
  const theme = createTheme({
    palette: {
      neutral: {
        main: "#00634A",
        contrastText: "#fff",
      },
    },
  });

  useEffect(() => {
    setValue(props?.value);
  }, [props?.value]);

  const onClick = (e) => {
    setValue(e.target.value);
    props.onClick(e);
  };
  return (
    <div
    className="stackButtonsDiv"
  >
    <span>{t(name)}</span>
    <ThemeProvider theme={theme}>
      <Stack
        style={{
          pointerEvents: disabled ? "none" : "auto",
        }}
        spacing={2}
        direction="row"
      >
        <Button
          value="Yes"
          name={name}
          color="neutral"
          onTransitionEnd={(e) => props.onLoad(e)}
          onClick={(e) => onClick(e)}
          className={
            ["yes", "Yes"].includes(value)
              ? props.disabled ? "disabledYesButton" : "activeYesButton"
              : props.disabled ? "disabledNoButton" : "inActiveNoButton"
          }
          data-testId={props.name + "True"}
          disabled={props.disabled}
        >
          {t("Yes")}
        </Button>
        <Button
          value="No"
          name={name}
          color="neutral"
          onTransitionEnd={(e) => props.onLoad(e)}
          onClick={(e) => onClick(e)}
          className={
            ["no", "No"].includes(value)
              ? props.disabled ? "disabledYesButton" : "activeYesButton"
              : props.disabled ? "disabledNoButton" : "inActiveNoButton"
          }
          data-testId={props.name + "False"}
          disabled={props.disabled}
        >
          {t("No")}
        </Button>
      </Stack>
    </ThemeProvider>
    </div>
  );
}

export default StackButtons;
